/* Shared storefront footer and tablet header behavior. */
(() => {
  const setupNewsletterValidation = () => {
    const input = document.querySelector('#hn-ui-email');
    const error = document.querySelector('#hn-ui-email-error');
    if (!input || !error) return;
    input.addEventListener('invalid', (event) => {
      event.preventDefault();
      error.textContent = input.validity.valueMissing ? 'This field is required' : 'This email is invalid';
      error.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      input.focus();
    });
    input.addEventListener('input', () => {
      if (!input.validity.valid) return;
      error.hidden = true;
      error.textContent = '';
      input.setAttribute('aria-invalid', 'false');
    });
  };
  const init = () => {
    setupNewsletterValidation();
    const tabletBreakpoint = window.matchMedia('(min-width: 750px) and (max-width: 1024px)');
    const header = document.querySelector('#header-component');
    const originalMenuStyle = header?.dataset.menuStyle;
    const syncTabletMenu = () => {
      if (!header) return;
      header.dataset.menuStyle = tabletBreakpoint.matches ? 'drawer' : originalMenuStyle;
    };
    syncTabletMenu();
    tabletBreakpoint.addEventListener('change', syncTabletMenu);
    const footerBreakpoint = window.matchMedia('(max-width: 1023px)');
    const syncFooterAccordions = () => {
      document.querySelectorAll('.hn-ui-footer__links details').forEach((section) => {
        section.open = !footerBreakpoint.matches;
      });
    };
    syncFooterAccordions();
    footerBreakpoint.addEventListener('change', syncFooterAccordions);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
